<template>
  <CheckoutWrapper ref="checkoutWrapperRef" :config="config" @goNext="goNext"
    style="color: rgba(var(--theme-primaria))" v-if="logged">

    <template #donation>
      <Donation />
    </template>
    
    <template #bonus>
      <Bonus @next="$refs.checkoutWrapperRef.goNext()" />
    </template>

    <template #acknowledgement>
      <Acknowledgement />
    </template>

    <template #resume>
      <Resume>
        
        <template #payrolldeduction>
          <Payroll 
            v-if="paymentInstallments.payrolldeduction"
            :params="paymentInstallments.payrolldeduction"
            @redirect="paymentRedirect($event)"      
            v-model="activePaymentMethod"
            />
        </template>
        <template #pix v-if="recurrency == 1">
          <Pix
            v-if="paymentInstallments.pix"
            :params="paymentInstallments.pix"
            @redirect="paymentRedirect($event)"
            :open-panel="openPanel" @set-open-panel="setOpenPanel"
            v-model="activePaymentMethod"
            />
        </template>

        <template #pixautomatic v-if="recurrency != 1">
          <PixAutomatic
            v-if="paymentInstallments.pixautomatic"
            :params="paymentInstallments.pixautomatic"
            @redirect="paymentRedirect($event)"
            :open-panel="openPanel" @set-open-panel="setOpenPanel"
            v-model="activePaymentMethod"
            />
        </template>

        <template #creditcard>
          <CreditCard v-if="paymentInstallments.creditcard" @redirect="paymentRedirect($event)"
            :params="paymentInstallments.creditcard" :open-panel="openPanel" @set-open-panel="setOpenPanel" 
            v-model="activePaymentMethod"
            />
        </template>

        <template #ticket>
          <Boleto v-if="paymentInstallments.ticket" @redirect="paymentRedirect($event)" 
            :params="paymentInstallments.ticket"
            :open-panel="openPanel" @set-open-panel="setOpenPanel" 
            v-model="activePaymentMethod"
            />
        </template>

        <template #debitaccount>
          <Debit v-if="paymentInstallments.debitaccount" @redirect="paymentRedirect($event)"
            :params="paymentInstallments.debitaccount" :open-panel="openPanel" @set-open-panel="setOpenPanel"
            v-model="activePaymentMethod"
            />
        </template>
      </Resume>
      <ConsentTerm />
    </template>


  </CheckoutWrapper>
</template>

<script>
// VUEX
import { mapGetters, mapActions } from "vuex";

// Checkout Core Slots
import Donation from "./Donation.vue";
import Acknowledgement from "./Acknowledgement.vue";
import Bonus from "./Bonus.vue";
import Resume from "./Resume.vue";
import CheckoutWrapper from "./CheckoutWrapper.vue";

// Checkout Payment Slots
import Boleto from "./Payment/Boleto.vue";
import CreditCard from "./Payment/CreditCard.vue";
import Payroll from "./Payment/Payroll.vue";
import Debit from "./Payment/Debit.vue";
import Pix from "./Payment/Pix.vue";
import PixAutomatic from "./Payment/PixAutomatic.vue";

import { Routes } from "@/scripts/models/enums/routes.enum.js";

// Template
import ConsentTerm from "./ConsentTerm.vue";

// Services
import CampaignService from "@/scripts/services/campaign.service";
import CartService from "@/scripts/services/cart.service"

// Enums
import PaymentMethod from "../../../scripts/models/enums/paymentMethod.enum";

export default {
  components: {
    ConsentTerm,
    Donation,
    Acknowledgement,
    Resume,
    Bonus,
    CheckoutWrapper,

    Boleto,
    CreditCard,
    Payroll,
    Debit,
    Pix,
    PixAutomatic,
  },
  data() {
    return {
      openPanel: null,
      campaignService: new CampaignService(),
      cartService: new CartService(),
      PaymentMethod: PaymentMethod,
      paymentMethods: {},
      activePaymentMethod: null,
      config: {
        bonus: true,//this.isInMaintenanceValue && this.isInMaintenanceValue.isInMaintenanceValue,
        before: "acknowledgement", // Antes de qual tab o bonus vai aparecer
      },
    };
  },
  computed: {
    ...mapGetters([
      "checkoutValue",
      "isInMaintenanceValue",
      "cartLocal",
      "cartItems",
      "logged",
      "reloadCart",
      "mergedCart",
      "paymentInstallments",
      "campaignDonationProduct",
      "recurrency"
    ]),
  },
  watch: {
    isInMaintenanceValue(val) {
      //this.config.bonus = val.isInMaintenanceValue
    },
    logged(newValue, oldValue) {
      if (this.reloadCart || ((oldValue == false || oldValue === null) && newValue)) {
        this.setMergedCart(false)
        this.saveCartitems();
      }
    },
  },
  async created() {
    await this.getProfile();
    this.setTabs();
    this.refreshCart()
    this.saveCartitems();
  },
  mounted() {
    const key = process.env.VUE_APP_GOOGLE_KEY_RECAPTCHA_V3;
    var script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
    document.head.appendChild(script);
  },
  methods: {
    ...mapActions(["setTabs", "getProfile", "setReloadCart", "updateCart", "setMergedCart", "refreshCart"]),
    goNext() {
      this.setOpenPanel(null);
    },
    setOpenPanel(panel) {
      this.openPanel = panel;
    },
    getPaymentIndex(name){
      return this.paymentMethods.findIndex(x => x.name === name)
    },
    
    saveCartitems() {
      if (this.reloadCart) this.setReloadCart(false);
      let items = this.cartItems.map(item => {
        if (item.donationProduct) {
          return {
            projectId: item.project.id,
            donationProductId: item.donationProduct.id
          };
        } else {
          return {
            projectId: item.project.id
          };
        }
      })
      
      this.mergeCartItems(items)
    },
    mergeCartItems(items) {
      this.cartService.mergeCartItems(items).then((data) => {
        // Add campaign product if exist
        if (this.$store.getters.cartLocal && this.$store.getters.cartLocal.campaignProduct) {
          data.campaignProduct = this.cartLocal.campaignProduct
          data.campaignProductId = this.cartLocal.campaignProductId
        }

        if (data && data.cartItems) {
          this.updateCart(data);
          this.setMergedCart(true)
        }
      });
    },
    paymentRedirect(payment) {
      if (payment) {
        this.$router.push(Routes.web.OrderApproved);
      }
      this.$router.push({
        name: Routes.web.OrderApproved,
        query: { method: payment.method },
        params: { data: payment.data },
      });
    },
  },
};
</script>
